import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "anadear_cookie_consent";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const decide = (choice) => {
    try { localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() })); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-[420px] z-[9999] bg-[#1c1c1e] text-white rounded-2xl shadow-2xl border border-white/10 p-5"
    >
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 shrink-0 rounded-lg bg-[#b8935f]/20 grid place-items-center text-[#d9b98a]">
          <Cookie size={18} />
        </span>
        <div>
          <h3 className="font-display text-[16px] mb-1">We value your privacy</h3>
          <p className="text-white/60 text-[13px] leading-relaxed">
            We use essential cookies to make our site work, and optional analytics cookies to
            understand how it's used. You can accept all, or keep only essentials. Read our{" "}
            <Link to="/cookie-policy" className="text-[#d9b98a] underline hover:text-white">Cookie Policy</Link>.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4 justify-end">
        <button
          onClick={() => decide("essential")}
          data-testid="cookie-essential-btn"
          className="px-4 py-2 rounded-lg border border-white/20 text-[13px] text-white/80 hover:bg-white/10 transition-colors"
        >
          Essentials only
        </button>
        <button
          onClick={() => decide("all")}
          data-testid="cookie-accept-btn"
          className="px-5 py-2 rounded-lg bg-[#b8935f] text-white text-[13px] font-medium hover:bg-[#a67f4d] transition-colors"
        >
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
